/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpHelperService } from './http-helper.service';

@Injectable({
  providedIn: 'root'
})
export class PwcsService {
  private baseUrl = `${environment.endpoint}common/pwcs`;

  constructor(private httpHelperService: HttpHelperService) {}

  async getPwcs(baseId: string): Promise<any> {
    try {
      return await this.httpHelperService.requestPromise(
        'GET',
        `${this.baseUrl}/${baseId}`,
        undefined
      );
    } catch (error) {
      throw error;
    }
  }
}
/* PavCon, LLC Proprietary.All rights reserved 2022 */
